import withRoot from "../../modules/withRoot" // --- Post bootstrap -----
import React from "react"
import AppFooter from "../../modules/views/AppFooter"
import AppAppBar from "../../modules/views/AppAppBar"
import ResultsView from "../../modules/views/results/Results"

function Results({ location }) {
  return (
    <React.Fragment>
      <AppAppBar />
      <ResultsView answers={location.state} />
      <AppFooter />
    </React.Fragment>
  )
}

export default withRoot(Results)
